import React, { useLayoutEffect, useState, useEffect, useRef } from "react";
import CanvasParticles, { ICanvasParticles } from "./CanvasParticles";

interface ICanvasParticlesWrapper {
  showCanvasOnTop?: boolean;
  canvasParticlesConfig?: Partial<ICanvasParticles>;
  centerCanvasWrapper?: boolean;
  extraHeight?: number;
  heightRatio?: number;
  children?: React.ReactNode;
  className?: string;
}

const CanvasParticlesWrapper = ({
  showCanvasOnTop = false,
  canvasParticlesConfig,
  centerCanvasWrapper = true,
  extraHeight,
  heightRatio = 1.2,
  children,
  className = ''
}: ICanvasParticlesWrapper) => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [sectionHeight, setSectionHeight] = useState<number>();
  const [sectionWidth, setSectionWidth] = useState<number>();

  useEffect(() => {
    const handleResize = () => {
      if (!sectionRef.current) return;

      setSectionHeight(sectionRef.current.clientHeight + (extraHeight || 0));
      setSectionWidth(sectionRef.current.clientWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [extraHeight]);

  return (
    <div className={`relative w-full h-fit ${className}`}>
      <div ref={sectionRef} className="relative w-full z-10">
        {children}
      </div>

      <div
        className={`${
          showCanvasOnTop ? "z-50" : "z-0"
        } absolute w-full left-0 ${
          centerCanvasWrapper ? "-top-1/4 -bottom-1/4" : "top-0"
        } pointer-events-none`}
      >
        {sectionHeight && sectionWidth && (
          <CanvasParticles
            height={sectionHeight * heightRatio}
            width={sectionWidth}
            colors={["42, 210, 201", "0, 183, 79", "155, 38, 182"]}
            minRadius={5}
            maxRadius={15}
            {...canvasParticlesConfig}
          />
        )}
      </div>
    </div>
  );
};

export default CanvasParticlesWrapper;
